import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import drawItActions from 'redux/actions/drawItActions'
import pickerSelector from 'redux/selectors/picker/picker_selector'
import Modalizer from 'components/modalizer/modalizer'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import NearpodPicker from 'components/nearpod_picker/nearpod_picker'

class DrawItBackgroundImagePicker extends PureComponent {

	constructor() {
		super()
		this.onFilePicked = this.onFilePicked.bind(this)
	}

	onFilePicked(file) {
		this.props.actions.filePicked(this.acceptedFiles(), file, false)
	}

	acceptedFiles() {
		return ['image']
	}

	render() {
		return (
			<Modalizer width='570px' height={this.props.pickerType!=='web'?'564px':''} nopadding={true} closeAction={this.props.actions.closeModal}>
				<NearpodPicker
					onFilesPicked={this.onFilePicked}
					closeHandler={this.props.actions.closeModal}
					pickerType={this.props.pickerType}
					accept={this.acceptedFiles()}
					multiselect={false}
					onFileError={this.props.actions.fileError}
					googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
				/>
			</Modalizer>
		)
	}
}

DrawItBackgroundImagePicker.propTypes = {
	modalName: PropTypes.string,
}

function mapStateToProps(state) {
	return pickerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: drawItActions.cancelBackgroundImagePicker,
		filePicked: drawItActions.uploadBackgroundImage,
		fileError: drawItActions.uploadBackgroundImageError,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DrawItBackgroundImagePicker)

export { DrawItBackgroundImagePicker }
